import React, { useState } from "react";
import { toast } from "react-toastify";
import Table from "../../../../components/elements/table/Table";
import { setTitle } from "../../../../helpers/MetaTag";
import { handleFilterChange } from "../../../../helpers";
import DeleteModal from "../../../../components/common/DeleteModal";
import { useDebounce } from "../../../../hooks/useDebounce";
import LimitSelect from "../../../../components/elements/LimitSelect";

// import { useGetPermission } from "../../hooks/useGetPermission";
import Search from "../../../../components/form/Search";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { transactionDelete, transactionList } from "../../../../services/transactionService";
import Switch from "../../../../components/form/Switch";
import Badge from "../../../../components/elements/Badge";
import ManageTaxDrawer from "../../../../components/sections/admin/Tax/Drawer/ManageTaxDrawer";
import Button from "../../../../components/form/Button";
import { postOrdering, postStatusChange } from "../../../../services/postService";
import TableControls from "../../../../components/elements/TableControls";

const Taxs = () => {
  setTitle("Tax");
  //   const { permission, status } = useGetPermission("faq");

  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "ordering",
  });

  const data = [
    {
      id: "txr_1MxwYsKcQJH1hdmfKAOaBHSO",
      type: "Utah rate",
      region: "United States",
      description: "State tax rate applicable in Utah, USA.",
      rate: "7.19%",
      status: 1,
      created: "Apr 18, 2023",
    },
    {
      id: "txr_1MxvvaKcQJH1hdmfbGHL5CXC",
      type: "GST",
      region: "India",
      description: "Goods and Services Tax applicable across India.",
      rate: "7.19%",
      status: 2,
      created: "Apr 18, 2023",
    },
    {
      id: "txr_1Mxp6rKcQJH1hdmfuYkrQwh4",
      type: "Utah rate",
      region: "United States",
      description: "Standard Utah state tax for applicable transactions.",
      rate: "7.19%",
      status: 1,
      created: "Apr 17, 2023",
    },
  ];
  const {
    data: newData,
    isLoading,
    updateData,
    isFetching,
  } = useQuery({
    queryKey: ["tax", filters, search],
    queryFn: async () => {
      const res = await transactionList({
        ...filters,
        ...(search && { keyword: search }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  //   FAQ status change handler =================>
  const { mutate: statusChangeHandler, isPending: statusChangeInPending } = useMutation({
    mutationFn: async ({ id, status }) => {
      queryClient.setQueryData(["tax", filters, search], (state) => {
        if (state) {
          let stateData = JSON.parse(JSON.stringify(state?.data));
          stateData = (stateData || []).map((elm) =>
            elm?._id === id ? { ...elm, status: elm?.status === 1 ? 2 : 1 } : elm
          );
          return { ...state, data: stateData };
        }
      });
      const res = await postStatusChange({
        ids: id,
        status,
      });
      return { res, payload: { id, status } };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status !== 200) {
        queryClient.setQueryData(["tax", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = (stateData || []).map((elm) =>
              elm?._id === payload?.id ? { ...elm, status: elm?.status === 1 ? 2 : 1 } : elm
            );
            return { ...state, data: stateData };
          }
        });
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const tableHeadData = [
    {
      _id: 2,
      name: "Type",
      align: "left",
    },
    {
      _id: 3,
      name: "Region",
      align: "left",
    },
    {
      _id: 4,
      name: "Description",
      align: "left",
    },
    {
      _id: 5,
      name: "Rate",
      align: "left",
    },
    {
      _id: 9,
      name: "Status",
      align: "left",
    },
    {
      _id: 13,
      name: "Action",
      align: "left",
    },
  ];

  console.log({ data });

  // Table Body Data =====================>
  const tableData = data?.map((item) => {
    return {
      _id: item?.id,
      rowData: [
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.type || "-",
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.region || "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.description || "-",
        },
        {
          _id: 5,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.rate || "-",
        },
        {
          _id: 9,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div className="flex gap-2 items-center">
              <Switch
                className={"!w-10 !h-5 before:!w-4 before:!h-4 peer-checked:before:!left-[22px]"}
                checked={item?.status === 1}
                onChange={() => {
                  statusChangeHandler({
                    id: item?._id,
                    status: item?.status === 1 ? 2 : 1,
                  });
                }}
              />
              <Badge
                type={item?.status === 1 ? "success" : "danger"}
                label={item?.status === 1 ? "Active" : "Inactive"}
              />
            </div>
          ),
        },
        {
          _id: 12,
          type: "action",
          align: "left",
          cellClass: "w-[5%]",
          actionData: [
            {
              _id: 1,
              name: "Edit",
              icon: "fa-regular fa-pen-to-square",
              onClick: () => {
                setModalOpen({ isOpen: true, data: item });
              },
            },
            {
              _id: 4,
              name: "Delete",
              icon: "fa-regular fa-trash-can",
              standout: true,
              onClick: () => {
                setDeleteModal({
                  isOpen: true,
                  data: item,
                });
              },
            },
          ],
        },
      ],
    };
  });

  // add or edit FAQ =================>
  function faqManageResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        if (filters?.page === 1) {
          queryClient.setQueryData(["tax", filters, search], (state) => {
            if (state) {
              let stateData = JSON.parse(JSON.stringify(state?.data));
              stateData = [...stateData, res?.data];
              return { ...state, data: stateData };
            }
          });
          if (data?.metadata?.totalDocs > filters?.limit) {
            queryClient.invalidateQueries(["tax", filters, search]);
          }
        } else {
          setFilters((pre) => ({ ...pre, page: 1 }));
        }
      }
      if (res?.status === 200) {
        queryClient.setQueryData(["tax", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = stateData?.map((item) => (item?._id === res?.data?._id ? { ...item, ...res?.data } : item));
            return { ...state, data: stateData };
          }
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          queryClient.invalidateQueries(["tax", filters, search]);
        }
      }
      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message || res?.error);
    }
  }

  //   FAQ delete handler =================>
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await transactionDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return { res, payload: Array.isArray(payload) ? payload : [payload] };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        setSelectedItems([]);
        queryClient.setQueryData(["tax", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = (stateData || [])?.filter((item) => !payload?.includes(item?._id));
            return { ...state, data: stateData };
          }
        });

        if (data?.metadata?.totalDocs > filters?.limit) {
          queryClient.invalidateQueries(["tax", filters, search]);
        }
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  async function postOrderingHandler(newData, oldData) {
    const ordering_data = newData?.map((item, i) => ({
      id: item?._id,
      ordering: i,
    }));
    const res = await postOrdering({ ordering_data });
    if (res?.status !== 200) {
      if (res?.status !== 200) {
        queryClient.setQueryData(["tax", filters, search], (state) => {
          if (state) {
            return { ...state, data: oldData };
          }
        });
        toast.warning(res?.message || res?.error);
      }
    }
  }

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        <div className="font-bold text-lg xl:text-3xl text-primary">Tax Management</div>
        <div className="flex items-center gap-3">
          <TableControls
            limit={filters?.limit}
            totalDocs={data?.metadata?.totalDocs}
            onLimitChange={(val) => handleFilterChange("limit", val, setFilters)}
            onSearch={(val) => {
              setKeyword(val);
              handleFilterChange("page", 1, setFilters);
            }}
          />
          <div className="relative">
            <Button
              buttonClasses={
                "!bg-transparent border border-transparent !h-10 hover:!bg-primary/10 hover:!border-primary/10"
              }
              buttonLabel={"Create New"}
              buttonLabelClasses={"font-medium !text-sm text-primary"}
              buttonFunction={() => setModalOpen({ isOpen: true, data: null })}
            />
          </div>
        </div>
      </div>

      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        isFetching={isFetching}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
      />

      <ManageTaxDrawer
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={faqManageResponse}
      />
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      />
    </div>
  );
};

export default Taxs;
